import CryptoJS from "crypto-js";
import { handleResponseError } from "./errorHandling";
import config from "../utils/config";
import {
  authAxiosInstance,
  quicklinkAxiosInstance,
  workflowAxiosInstance,
} from "./apis/axiosInstance";

export const getAccessToken = () => {
  if (sessionStorage.getItem("access_token")) {
    const bytes = CryptoJS.AES.decrypt(
      sessionStorage.getItem("access_token"),
      config.tokenKey
    );
    const jsonString = bytes.toString(CryptoJS.enc.Utf8);
    const token = JSON.parse(jsonString);
    return token;
  } else {
    return "";
  }
};

export const getAxiosInstance = (url) => {
  if (url?.startsWith(config.authUrl)) return authAxiosInstance;
  else if (url?.startsWith(config.workflowUrl)) return workflowAxiosInstance;
  else if (url?.startsWith(config.quicklinkUrl)) return quicklinkAxiosInstance;
};

export const getAPI = async (url) => {
  const axiosInstance = getAxiosInstance(url);
  try {
    const access_token = getAccessToken();
    const config = {
      headers: {
        "x-access-token": access_token,
      },
    };
    const response = await axiosInstance.get(url, config);
    const result = handleResponseError(response);
    if (result.error) {
      return { error: true, message: result.message };
    }
    return { data: result, error: false };
  } catch (res) {
    if (res && res.response && res.response.data && res.response.data.message) {
      if (
        res &&
        res.response &&
        res.response.status &&
        res.response.status === 401
      ) {
        window.location.reload();
      }
      return {
        error: true,
        message: res.response.data.message,
        code: res?.response?.status,
      };
    }
    return {
      error: true,
      message: "Something went wrong",
      code: res?.response?.status,
    };
  } finally {
  }
};

export const postAPI = async (url, body) => {
  const axiosInstance = getAxiosInstance(url);
  try {
    const access_token = getAccessToken();
    const config = {
      headers: {
        "x-access-token": access_token,
      },
    };
    const response = await axiosInstance.post(url, body, config);
    const result = handleResponseError(response);
    if (result.error) {
      return { error: true, message: result.message };
    }
    return { data: result, error: false };
  } catch (res) {
    if (res && res.response && res.response.data && res.response.data.message) {
      if (
        res &&
        res.response &&
        res.response.status &&
        res.response.status === 401
      ) {
        window.location.reload();
      }
      return { error: true, message: res.response.data.message };
    }
    return { error: true, message: "Something went wrong" };
  } finally {
  }
};

export const putAPI = async (url, body) => {
  const axiosInstance = getAxiosInstance(url);
  try {
    const access_token = getAccessToken();
    const config = {
      headers: {
        "x-access-token": access_token,
      },
    };
    const response = await axiosInstance.put(url, body, config);
    const result = handleResponseError(response);
    if (result.error) {
      return { error: true, message: result.message };
    }
    return { data: result, error: false };
  } catch (res) {
    if (res && res.response && res.response.data && res.response.data.message) {
      return { error: true, message: res.response.data.message };
    }
    return { error: true, message: "Something went wrong" };
  } finally {
  }
};

export const deleteAPI = async (url, body) => {
  const axiosInstance = getAxiosInstance(url);
  try {
    const access_token = getAccessToken();
    const config = {
      headers: {
        "x-access-token": access_token,
      },
    };
    const response = await axiosInstance.delete(url, body, config);
    const result = handleResponseError(response);
    if (result.error) {
      return { error: true, message: result.message };
    }
    return { data: result, error: false };
  } catch (res) {
    if (res && res.response && res.response.data && res.response.data.message) {
      return { error: true, message: res.response.data.message };
    }
    return { error: true, message: "Something went wrong" };
  } finally {
  }
};
